
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/override",
      function () {
        return require("private-next-pages/override/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/override"])
      });
    }
  